class Zip {  
    
    getRegion( zip ){
        console.log('Zip getRegion', zip);
        let region = false;
            
        let zipString = (Number.isFinite(zip) ) ? zip.toFixed() : zip;

        switch ( zipString.slice(0, 2) ) {
            case '00':
            case '01':
            case '02':
            case '03':
            case '04':
                region = "Lazio";
                break;
            case '05':
            case '06':
                region = "Umbria";
                break;
            case '07':
            case '08':
            case '09':
                region = "Sardegna";
                break;
            case '10':
            case '12':
            case '13':
            case '14':
            case '15':
            case '28':
                region = "Piemonte";
                break;
            case '11':
                region = "Val d'Aosta";
                break;
            case '16':
            case '17':
            case '18':
            case '19':
                region = "Liguria";
                break;
            case '20':
            case '21':
            case '22':
            case '23':
            case '24':
            case '25':
            case '26':
            case '27':
            case '46':
                region = "Lombardia";
                break;
            case '29':
            case '40':
            case '41':
            case '42':
            case '43':
            case '44':
            case '47':
            case '48':
                region = "Emilia-Romagna";
                break;
            case '30':
            case '31':
            case '32':
            case '35':
            case '36':
            case '37':
            case '45':
                region = "Veneto";
                break;
            case '33':
            case '34':
                region = "Friuli-Venezia Giulia";
                break;
            case '38':
            case '39':
                region = "Trentino-Alto Adige";
                break;
            case '50':
            case '51':
            case '52':
            case '53':
            case '54':
            case '55':
            case '56':
            case '57':
            case '58':
            case '59':
                region = "Toscana";
                break;
            case '60':
            case '61':
            case '62':
            case '63':
                region = "Marche";
                break;
            case '64':
            case '65':
            case '66':
            case '67':
                region = "Abruzzo";
                break;
            case '70':
            case '71':
            case '72':
            case '73':
            case '74':
            case '76':
                region = "Puglia";
                break;
            case '75':
            case '85':
                region = "Basilicata";
                break;
            case '80':
            case '81':
            case '82':
            case '83':
            case '84':
                region = "Campania";
                break;
            case '86':
                region = "Molise";
                break;
            case '87':
            case '88':
            case '89':
                region = "Calabria";
                break;
            case '90':
            case '91':
            case '92':
            case '93':
            case '94':
            case '95':
            case '96':
            case '97':
            case '98':
                region = "Sicilia";
                break;        
            default:
                region = false;
                break;
        }

        return region;
    }
}

export default new Zip();